import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, consultaPlacaDisponivel } from './types';

export const INITIAL_STATE: consultaPlacaDisponivel = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultaPlacaDisponivel {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_PLACA_DISPONIVEL_REQUEST: {
				break;
			}

			case Types.CONSULTA_PLACA_DISPONIVEL_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTA_PLACA_DISPONIVEL_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_PLACA_DISPONIVEL_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
